import { render, staticRenderFns } from "./ApproveUserSetting.vue?vue&type=template&id=eb85fa00"
import script from "./ApproveUserSetting.vue?vue&type=script&lang=js"
export * from "./ApproveUserSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports